export default __webpack_public_path__ + "static/media/adding-first-content.20d7cf9f.jpg";